import { IEditHubPayload, IGetHubList, IHubCreate, IHubDetails, IHubListSearch } from "../../../types/master/hubInterface";
import { HubActionTypes, HubActions } from "../../actionTypes/master/hubActionTypes";


export const createHub = (payload: IHubCreate): HubActionTypes => ({
  type: HubActions.CREATE_HUB,
  payload,
});

export const getHubList = (payload: IHubListSearch): HubActionTypes => ({
  type: HubActions.GET_HUB_LIST,
  payload,
});

export const setHubList = (hubList: Array<IGetHubList>) : HubActionTypes => ({
  type: HubActions.SET_HUB_LIST,
  payload: hubList
})

export const setHubListPageCount = (payload:number): HubActionTypes => ({
  type: HubActions.SET_HUB_LIST_PAGE_COUNT,
  payload
})

export const getHubDataById = (id: number): HubActionTypes => ({
  type: HubActions.GET_HUB_DATA_BY_ID,
  payload: id
})

export const setHubDataById = (payload: IHubDetails) => ({
  type: HubActions.SET_HUB_DATA_BY_ID,
  payload
})

export const editHub = (payload: IEditHubPayload) => ({
  type: HubActions.EDIT_HUB_DATA_BY_ID,
  payload,
});
